import { createContext } from 'react';

import { GetStaticData } from '../queries/get-static-data';

export const CurrentStaticDataContext = createContext<
  [GetStaticData.Output, ReturnType<typeof GetStaticData.useQuery>]
>(
  // @ts-expect-error - This is a placeholder value that should never be used
  undefined,
);
